import api from './api';

const supportRequestsApi = {
  getAll: (params) => api.get('/support-requests', { params }),
  getById: (id) => api.get(`/support-requests/${id}`),
  create: (data) => api.post('/support-requests', data),
  update: (id, data) => api.put(`/support-requests/${id}`, data),
  delete: (id) => api.delete(`/support-requests/${id}`),
  addMessage: (id, data) => api.post(`/support-requests/${id}/messages`, data),
  getStats: () => api.get('/support-requests/stats/summary'),
  getMarques: () => api.get('/support-requests/marques'),
  presignMessage: (requestId, { filename, contentType }) =>
    api.post(`/support-requests/${requestId}/messages/presign`, { filename, contentType }),
  confirmMessage: (requestId, data) =>
    api.post(`/support-requests/${requestId}/messages/confirm`, data),
  uploadMessageFile: (requestId, formData) =>
    api.post(`/support-requests/${requestId}/messages/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

export default supportRequestsApi;
